// src/navigation/NavigationListener.tsx

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { markNavigation } from "./navigationTracker";

/**
 * @description - A React component that listens to route changes and marks navigation events.
 * It should be placed inside the Router context to track navigation properly.
 */
const NavigationListener: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    markNavigation();
  }, [location]);

  return null;
};

export default NavigationListener;
